import renderReactClient from '../../render-react-client';
import ForgotUserIdForm from './ForgotUserIdForm';
import ForgotUserIdPromptForInfoForm from './ForgotUserIdPromptForInfoForm';

renderReactClient({
    ForgotUserIdForm,
    ForgotUserIdPromptForInfoForm
});
